import * as React from 'react';
import AddCircle from './AddCircle';
import AddSquare from './AddSquare';
import Calendar from './Calendar';
import CheckMark from './CheckMark';
import Envelope from './Envelope';
import FilledCheck from './FilledCheck';
import MapMarker from './MapMarker';
import Papers from './Papers';
import Question from './Question';
import Truck from './Truck';
import Warning from './Warning';

export interface IIconProps {
    name: string;
    style: React.CSSProperties;
    width: string;
    className: string;
    color?: string;
}

const Icon = (props : IIconProps) => {
    switch (props.name) {
      case "calendar":
        return <Calendar {...props} />;
    case "add-circle":
        return <AddCircle {...props} />;
    case "add-ssquare":
        return <AddSquare {...props} />;
    case "checkmark":
        return <CheckMark {...props} />;
    case "envelope":
        return <Envelope {...props} />;
    case "papers":
        return <Papers {...props} />;
    case "question":
        return <Question {...props} />;
    case "warning":
        return <Warning {...props} />;
    case "marker":
        return <MapMarker {...props} />;
    case "truck":
        return <Truck {...props} />;
    case "fillcheck":
        return <FilledCheck {...props} />;
    default:
        return null;
    }
  };
  
Icon.defaultProps = {
    style: {},
    width: "100%",
    className: ""
};

export default Icon;
